module.exports = __webpack_public_path__ + "static/service-1-0ab156a37ed981f6b6853a859fd601f6.jpg";